import { render, staticRenderFns } from "./ExamsListActionButtonIcon.vue?vue&type=template&id=d39ecef4&scoped=true&"
import script from "./ExamsListActionButtonIcon.vue?vue&type=script&lang=js&"
export * from "./ExamsListActionButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./ExamsListActionButtonIcon.vue?vue&type=style&index=0&id=d39ecef4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39ecef4",
  null
  
)

export default component.exports